import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-error',
    templateUrl: './error.component.html',
    standalone: false
})
export class ErrorComponent {
  message: string | undefined;

  constructor(router: Router) {
    this.message = router.getCurrentNavigation()?.extras.state?.['message'];
  }
}
